import enrollmentService from './services/enrollment.service';
import storage from '../helpers/storage';
import { debug } from 'util';

export const SET_ENROLLMENT = 'agent/SET_ENROLLMENT';

const initialState = {
  status: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ENROLLMENT: {
      return action.payload;
    }
    default:
      return state
  }
}

export const loadEnrollmentStatus = () => {
  return (dispatch) => {
    return enrollmentService.getEnrollmentStatus()
      .then((response) => {
        dispatch({
          type: SET_ENROLLMENT,
          payload: response
        });

        return response;
      });
  };
}

export const updateEnrollmentStatus = (value) => {
  return (dispatch, getState) => {
    const enrollmentId = getState().enrollment.id;

    return enrollmentService.updateEnrollmentStatus(enrollmentId, value)
      .then((response) => {
        dispatch({
          type: SET_ENROLLMENT,
          payload: response
        });

        return response;
      });
  };
}



// WEBPACK FOOTER //
// ./src/modules/enrollment.js